import { render, staticRenderFns } from "./EducationTab.vue?vue&type=template&id=6e5d8308&scoped=true&"
import script from "./EducationTab.vue?vue&type=script&lang=js&"
export * from "./EducationTab.vue?vue&type=script&lang=js&"
import style0 from "./EducationTab.vue?vue&type=style&index=0&id=6e5d8308&prod&lang=css&"
import style1 from "./EducationTab.vue?vue&type=style&index=1&id=6e5d8308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5d8308",
  null
  
)

export default component.exports